
export default {
    name: 'DocumentCard',

    props: {
        document: {
            type: Object,
            default: () => ({}),
        },
        documentsFiles: {
            type: Object,
            default: () => ({}),
        },
    },

    computed: {
        filePath() {
            return this.documentsFiles?.[this.document.document] || this.document.document_link || '';
        },
    },
};
